import React, { memo, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Sliders, HelpCircle } from 'react-feather';
import ReactTooltip from 'react-tooltip';
import AnomalyCard from './anomalyCard';
import CardLoader from '../content-loader/cardLoader';
import FilterPane from './filterPane';
import ApiFailureComp from './apiFailure';
import Pagination from '../common/pagination';
import { paginate } from '../../utils/paginate';
// import { mobile } from './../../utils/constants';

function AnomalyList(props) {
  const { anomaly, anomalyFiltered, filter, cardID } = props;
  const { selectAnomaly, selectfilter, apiFailure, updateAnomaly } = props;

  //Paginate State & events
  const [page, setPage] = useState({
    pageSize: 20,
    currentPage: parseInt(sessionStorage.getItem('currentPage'), 10) || 1
  });
  const pageChange = (pg, action, type) => {
    let pagestate = { ...page };
    pagestate.currentPage =
      type === 'next' ? pg + 1 : type === 'prev' ? pg - 1 : pg;
    sessionStorage.setItem('currentPage', pagestate.currentPage);
    let scroll = document.querySelector('.anomalyListCards');
    scroll.scrollTo({ top: 0, behavior: 'smooth' });
    if (action !== 'disabled') setPage(pagestate);
  };
  const handlePageChange = (pg) => pageChange(pg, 'active', 'current');
  const nextPage = (pg, action) => pageChange(pg, action, 'next');
  const previousPage = (pg, action) => pageChange(pg, action, 'prev');
  const anomalyPaginated = paginate(
    anomalyFiltered,
    page.currentPage,
    page.pageSize
  );

  //Filter Modal States
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleSelection = (sel) => {
    selectfilter(sel);
    let pagestate = { ...page };
    pagestate.currentPage = 1;
    sessionStorage.setItem('currentPage', 1);
    setPage(pagestate);
  };

  const AnomalyCount = anomalyFiltered.length > 0 && (
    <span className='anomalyCount'>
      Showing {anomalyFiltered.length} results
    </span>
  );

  useEffect(() => {
    let scroll = document.querySelector('.anomalyListCards');
    let position = parseInt(sessionStorage.getItem('scroll'), 10) || 0;
    if (scroll && position > 0) {
      setTimeout(
        () => scroll.scrollTo({ top: position, behavior: 'smooth' }),
        1000
      );
    }
  }, []);

  //tooltip of card information
  const CardInfo = () => {
    let values = ['High', 'Medium', 'Low'];
    return (
      <ReactTooltip
        id='Info'
        type='light'
        effect='solid'
        aria-haspopup='true'
        className='cardInfoTooltip'
      >
        <h6>Card Severity</h6>
        <p style={{ color: 'grey' }}>
          The dots at the top-left of each card denotes the severity level. Our
          algorithm assigns the severity automatically
        </p>
        {values.map((s, i) => (
          <div className='info-tooltip' key={i}>
            <i className={`fa fa-circle ${s.toLowerCase()}`}></i>
            <p className='m-0'>{s}</p>
          </div>
        ))}
      </ReactTooltip>
    );
  };

  //1. Anomaly container header
  const AnomalyListHeader = (
    <Row className='m-0 anomalyListHeader'>
      <p className='m-0'>Alert List</p>
      <div style={{ flex: 1 }}></div>
      {AnomalyCount}
      <HelpCircle size={20} data-tip data-for='Info' />
      <Sliders size={20} data-tip='Filters' onClick={() => setShow(true)} />
    </Row>
  );

  //2. Anomaly container body
  const AnomalyList = (
    <Row
      className={`anomalyListCards ${
        anomalyFiltered.length === 0 ? 'flex-fill' : ''
      }`}
    >
      {anomalyFiltered.length > 0 &&
        anomalyPaginated.map((aan, index) => (
          <AnomalyCard
            anomaly={aan}
            index={index}
            key={index}
            id={cardID}
            onSelect={(ann) => selectAnomaly(ann)}
            updateAnomaly={(ann) => updateAnomaly(ann)}
          />
        ))}
      {anomaly.length === 0 && <CardLoader className='cardLoader' />}
      {anomalyFiltered.length === 0 && (
        <div className='noAlert'>
          No alerts found for your selection. Clear all selection to see alerts
        </div>
      )}
    </Row>
  );

  //3. Pagination
  const PageSelector = (
    <Row className='anomalyListPaginate'>
      {anomalyFiltered.length > page.pageSize && (
        <>
          <p className='m-0 flex-fill'>Cards per page: {page.pageSize}</p>
          <Pagination
            itemCount={anomalyFiltered.length}
            pageSize={page.pageSize}
            currentPage={page.currentPage}
            onPageChange={handlePageChange}
            nextPage={nextPage}
            previousPage={previousPage}
            sliderSize={3}
          />
        </>
      )}
    </Row>
  );

  return (
    <>
      <Col xs={12} md={4} lg={4} className='anomaly-pane fadeInDown'>
        {/* {!mobile && <Row className='header'>Watchtower</Row>} */}
        <div className='anomalyList'>
          {AnomalyListHeader}
          {!apiFailure && AnomalyList}
          {!apiFailure && PageSelector}
          {apiFailure && <ApiFailureComp />}
        </div>
        {CardInfo()}
      </Col>
      <FilterPane
        show={show}
        data={anomaly}
        filter={filter}
        handleClose={handleClose}
        submitSelection={(selection) => handleSelection(selection)}
      />
    </>
  );
}

export default memo(AnomalyList);
